<template>
    <div id="errors-box">
        <div id="switch-errors" class="bg-violet text-white w-100 py-2 border-0 rounded-top-10 mt-4 px-2">
            <div class="d-flex px-1 align-items-center">
                <b-icon icon="exclamation-triangle-fill" font-scale="1.2" />
                <span class="ml-2 p-0 font-weight-bold"><t errorsBox.errorsTitle /></span>
            </div>
        </div>
        <div class="bg-gris-pro rounded-bottom-10 px-3 py-2">
            <div class="py-1" v-for="(autoCorrect, index) in autoCorrectsList" :key="autoCorrect">
                <div class="d-flex w-100 justify-content-between">
                    <div>
                        <span class="font-weight-bold" v-if="index == 'roundCorner'"><t errorsBox.roundCorner /></span>
                        <span class="font-weight-bold" v-else-if="index == 'smallCircleRemove'"><t errorsBox.smallCircleRemove /></span>
                        <span class="font-weight-bold" v-else-if="index == 'roundingRemove'"><t errorsBox.roundingRemove /></span>
                        <span class="font-weight-bold" v-else-if="index == 'minimalMaterialCrop'"><t errorsBox.minimalMaterialCrop /></span>
                        <span class="font-weight-bold" v-else-if="index == 'minimalMaterialRemove'"><t errorsBox.minimalMaterialRemove /></span>
                        <span class="font-weight-bold" v-else-if="index == 'amorce'"><t errorsBox.amorce /></span>
                        <b-icon class="cursor-pointer" icon="info-circle-fill" font-scale=".9" @click="tutorial(index)" />
                    </div>
                    <span class="bg-jaune py-1 px-2 rounded-10 small font-weight-bold">{{autoCorrect}}</span>
                </div>

                <transition-group name="bounce">
                    <div class="fly-over-setting my-2 position-relative" v-if="tuto == index" key="tuto" @click="tuto = null">
                        <div class="bg-white rounded-10 px-3 py-2 text-left">
                            <p class="text-dark mb-0 line-height">
                                <t v-if="index == 'roundCorner'" errorsBox.tutoRoundCorner />
                                <t v-else-if="index == 'smallCircleRemove'" errorsBox.tutoSmallCircleRemove />
                                <t v-else-if="index == 'roundingRemove'" errorsBox.tutoRoundingRemove />
                                <t v-else-if="index == 'minimalMaterialCrop'" errorsBox.tutoMinimalMaterialCrop />
                                <t v-else-if="index == 'minimalMaterialRemove'" errorsBox.tutoMinimalMaterialRemove />
                                <t v-else-if="index == 'amorce'" errorsBox.tutoAmorce />
                            </p>
                        </div>
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { BIcon, BIconExclamationTriangleFill, BIconInfoCircleFill } from 'bootstrap-vue';

    export default {
        components: {
            BIcon,
            BIconExclamationTriangleFill,
            BIconInfoCircleFill
        },

        data(){
            return {
                tuto: null
            }
        },

        computed: {
            ...mapGetters([
                'autoCorrectsList'
            ]),
        },

        methods: {
            tutorial(element) {
                if (this.tuto != element) {
                    this.tuto = element;
                } else {
                    this.tuto = null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bg-violet {
        background: #99294B;
    }
    .fly-over-setting:after {
        border-bottom: 15px solid #fff;
    }
</style>
